<template>
  <v-list-item
    link
    @click="logout"
  >
    <v-list-item-icon>
      <v-icon>mdi-logout</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>Logout</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import axios from 'axios';

export default {
  name: 'DefaultDrawerLogout',
  methods: {
    async logout() {
      try {
        await axios.post('auth/logout');
        localStorage.clear();
        this.$store.commit('app/authUser', null);
        this.$router.push('/login');
      } catch (err) {
        alert(err.response?.data?.message || 'Gagal logout');
      }
    },
  },
};
</script>
